import { KeyboardDoubleArrowDown } from '@mui/icons-material';
import { Stack } from '@mui/material';
import React from 'react';

const ScheduleTableDropdown = () => {
  return (
    <Stack
      direction="row"
      gap={0.5}
      alignItems="center"
      sx={{
        position: 'relative',
        '&:hover .dropdown-icon': {
          opacity: 1,
          visibility: 'visible',
        },
      }}
    >
      <Stack
        sx={{
          width: 16,
          height: 16,
          borderRadius: 36,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      />
      <KeyboardDoubleArrowDown
        className="dropdown-icon"
        sx={{
          width: 16,
          height: 16,
          color: 'text.base',
          transition: 'all 150ms ease-in-out',
          opacity: 0,
          visibility: 'hidden',
        }}
      />
    </Stack>
  )
}

export default ScheduleTableDropdown;
